module.exports = __webpack_public_path__ + "static/media/white@2x.43b82a7d.png";